import React from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
  IconButton,
} from "@material-ui/core";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  transactionBox: {
    position: "relative",
    zIndex: "9",
    padding: "50px 0",
    "& .grayText": {
      color: theme.palette.text.secondary,
    },
    "& img": {
      width: "auto",
      maxWidth: "100%",
    },
    "& .icontableBox": {
      width: "auto",
      maxWidth: "100%",
      [theme.breakpoints.down("xs")]: {
        maxWidth: "15px",
      },
    },
    "& h2": {
      lineHeight: "60px",
      [theme.breakpoints.down("xs")]: {
        lineHeight: "30px",
      },
    },
    "& .transactioncoinBox": {
      background: theme.palette.background.cardinner,
      padding: "10px",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: "8px",
      [theme.breakpoints.down("xs")]: {
        marginTop: "20px",
      },
    },
    "& .transactionlistBox": {
      background: theme.palette.background.cardinner,
      borderRadius: "8px",
      padding: "15px",
      [theme.breakpoints.down("xs")]: {
        padding: "0px",
      },
    },
  },
}));

function Transaction() {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.transactionBox}>
        <Container maxWidth="lg">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} lg={5} sm={5} md={5}>
              <AnimationOnScroll animateIn="animate__fadeInLeft">
                <img src="images/transaction.gif" alt="image" />
              </AnimationOnScroll>
            </Grid>
            <Grid item xs={12} lg={7} sm={7} md={7}>
              <AnimationOnScroll animateIn="animate__fadeInRight">
                <Typography variant="h4" color="primary">
                  The fastest-growing ecosystem in the crypto space, ready to
                  redefine your digital asset ownership.
                </Typography>
              </AnimationOnScroll>

              <Box className="displayStart ">
                <AnimationOnScroll animateIn="animate__fadeInUp">
                  <Box className="transactionlistBox ">
                    <Box className="transactioncoinBox displayStart">
                      <Box>
                        <Box className="displayStart ">
                          <img
                            src="images/bitcoin.png"
                            alt="images"
                            className="icontableBox"
                          />
                          &nbsp;&nbsp;
                          <Typography variant="body2" color="primary">
                            Bitcoin
                          </Typography>
                        </Box>
                        <Box align="center">
                          <Typography
                            variant="body1"
                            color="primary"
                            className="grayText"
                          >
                            4.6 Tps
                          </Typography>
                          <img src="images/chart.png" alt="images" />
                        </Box>
                      </Box>
                      <Box ml={2}>
                        <Box className="displayStart ">
                          <img
                            src="images/ethereum.png"
                            alt="images"
                            className="icontableBox"
                          />
                          &nbsp;&nbsp;
                          <Typography variant="body2" color="primary">
                            Ethereum
                          </Typography>
                        </Box>
                        <Box align="center">
                          <Typography
                            variant="body1"
                            color="primary"
                            className="grayText"
                          >
                            20 Tps
                          </Typography>
                          <img src="images/chart.png" alt="images" />
                        </Box>
                      </Box>
                      <Box ml={2}>
                        <Box className="displayStart ">
                          <img
                            src="images/ripple.png"
                            alt="images"
                            className="icontableBox"
                          />
                          &nbsp;&nbsp;
                          <Typography variant="body2" color="primary">
                            Ripple
                          </Typography>
                        </Box>
                        <Box align="center">
                          <Typography
                            variant="body1"
                            color="primary"
                            className="grayText"
                          >
                            1000 Tps
                          </Typography>
                          <img src="images/chart.png" alt="images" />
                        </Box>
                      </Box>
                      <Box ml={2}>
                        <Box className="displayStart ">
                          <img
                            src="images/fearo.png"
                            alt="images"
                            className="icontableBox"
                          />
                          &nbsp;&nbsp;
                          <Typography variant="body2" color="primary">
                            Fieres
                          </Typography>
                        </Box>
                        <Box align="center">
                          <Typography
                            variant="body1"
                            color="primary"
                            className="grayText"
                          >
                            3500 Tps
                          </Typography>
                          <img src="images/chart.png" alt="images" />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </AnimationOnScroll>
              </Box>

              <Box mt={2}>
                <Typography variant="body2" className="grayText">
                  Fieres is a disruptive payment platform that facilitates rapid
                  and streamlined transactions for individuals and enterprises.
                  Its superior transaction processing power of 10x compared to
                  the SWIFT standard optimises payment efficiency, reducing
                  costs and turnaround times involved in cross-border transfers.
                  Fieres enables secure and speedy global transactions,
                  transforming the future of payments and positioning itself as
                  the ideal solution for the contemporary global economy.
                </Typography>
              </Box>
              {/* <Box mt={2}>
                <Typography variant="body2" className="grayText">
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout.
                  The point of using Lorem Ipsum is that it has a more-or-less
                  normal distribution of letters, as opposed to using 'Content
                  here, content here', making it look like readable English.
                </Typography>
              </Box> */}
              {/* <Box mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  target="_blank"
                  href="https://fieroscan.com/"
                >
                  Explore Dapps
                </Button>
              </Box> */}
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Transaction;
